import { fetchApi } from './fetchApi';

export async function getInventoryUrl(token: string, id: number) {
  return fetchApi<string>('GET', `/inventories/${id}/url`, token);
}
